import type { FunctionComponent } from "react";

import { Text } from "./styles";

export const MynewsText: FunctionComponent = () => (
  <Text>
    <i>my</i>
    <b>NEWS</b>
  </Text>
);

MynewsText.displayName = "MynewsText";
